import { BaseObject } from './../shared/baseClass';
import { Gift } from '../gift/gift';

export class Registry extends BaseObject {
public id: string;
public paid: boolean;
public availableThankYouCards: number;
public paidThankyouCards: boolean;
public gifts: Gift[];
public symbol: string;
public guestFeePercent: number;
public coupleFeePercent: number;
public isLive: boolean;
public firstName: string;
public lastName: string;
public partnerFirstName: string;
public partnerLastName: string;
public registryName: string;
public weddingDay: number;
public weddingMonth: number;
public weddingYear: number;
public backgroundHeaderImageUrl: string;
public introductionText: string;
public currency: string;
public profileImageUrl: string;
public emailGuestPays: boolean;
public emailUpdates: boolean;
public stripePublicKey: string;
public feeMode: number;
public country: string;
public isDemo: boolean;
public defaultGiftPrice: number;
public created: Date;
public usedGiftAssistant: boolean;
public giftAssistantLocations: string[];
public giftSort: string[];
public hideIntroText: boolean;
public hideHashtag: boolean;
public hideIntroTitle: boolean;
public isWeddingRegistry: boolean;
public hashtag: string;
public introTitle: string;
public hasPassword: boolean;
public password: string;
public tier: string;
public partnershipId: string;
public source: string;
public campaign: string;
public hasUpdatedRegistry: boolean;
public hasCreatedOrEditedGifts: boolean;
public hideRecommendedAmount: boolean;
public showRecommendedAmount: boolean;
public font: string;
public layout: string;

public paypal: string;
public venmo: string;
public cashApp: string;
public customInstructions: string;
public hasCustomPaymentMethods: boolean;
public bitcoin: string;
public zelle: string;
public revolut: string;
public chequeOnTheDay: string;
public cashOnTheDay: string;
public guestCount: number;
public referalUserId: string;
public giftDeleteLimit: number;
public bankField1: string;
public bankField2: string;
public bankField3: string;
 public bankField4: string;
 public bankCountry: string;
public bank2Field1: string;
public bank2Field2: string;
public bank2Field3: string;
public bank2Field4: string;
public bank2Country: string;
public bank3Field1: string;
public bank3Field2: string;
public bank3Field3: string;
public bank3Field4: string;
public bank3Country: string;


 public introductionTextTranslation: string;
 public translationLanguage: string;
 public wise: string;
 public payId: string;
 public generalInstructions: string;
 public backgroundColour: string;
 public textColour: string;
 public imageShape: string;
 public fromAnonymous : boolean;
 public imageRepositionLeft: number;
 public imageRepositionUp: number;
 public imageRepositionZoom: number;
        public applyFontToGiftTitles: boolean;
    public doNotUpSellGuestCards: boolean;
    public showGiftAmounts: boolean;
    public customInstructionsLabel: string;
    public backgroundHeaderVideoUrl: string;
  public isOtherRegistry: boolean;
  public sections : Section[];
  
  public signupForWebsite: boolean;
  public signupForRegistry: boolean;
  public signupForGuestListRsvp: boolean;
  public signupForJustBrowsing: boolean;
  defaultMode: boolean;
  viewedIntro: boolean;
  lightenCoverImage: boolean;
  hasAiGifts: boolean;


}



export class Section {
  public name: string;
  
  public giftIds: string[];
  
}


// WEBPACK FOOTER //
// ./src/app/registry/registry.ts